<template>
  <section class="project-big-event">
    <div class="left-box">
      <div>
        <img
          src="./../../../../assets/imgs/project/projectBigEvent/xmgk.png"
          alt=""
        />
      </div>
      <div class="project-info">
        <div class="name">交子公园金融总部产业园4期</div>
        <div class="swiper-box">
          <a-carousel effect="fade">
            <div v-for="(img, i_index) in swiperList" :key="i_index">
              <img
                style="width: 100%; max-height: 300px"
                fit="fill"
                :src="img"
              />
            </div>
          </a-carousel>
        </div>
        <div class="des">
          交子公园金融总部产业园（四期）项目定位为国内一流银行总部，是按照国际先进理念打造的绿色、智能地标项目。项目以“适用、经济、美观、绿色、智能”为设计总体原则，办公标准为超甲级写字楼。项目开发将助力建设国家西部金融中心，加快交子公园金融商务区总部聚集，融入“成渝双城经济圈”战略，提升交子公园金融商务区形象，激发交子商圈活力，助力区域协同与城市经济高质量发展。
        </div>
        <div class="info-item cjdw">中国建筑第八工程局有限公司</div>
        <div class="info-item sjdw">中国建筑西南设计研究院有限公司</div>
        <div class="info-item jldw">成都衡泰工程管理有限责任公司</div>
        <div class="info-item xmtz">18.2亿</div>
        <div class="info-item jzmj">12.8万㎡</div>
      </div>
      <div
        :class="['btn', startState ? 'btn-active' : '']"
        @click="startCourse()"
      ></div>
    </div>
    <div class="right-box">
      <div>
        <img
          src="./../../../../assets/imgs/project/projectBigEvent/xmlc.png"
          alt=""
        />
      </div>
      <div class="list">
        <TransitionGroup tag="div" name="el-zoom-in-top">
          <div
            class="course-item"
            v-for="(course, c_index) in courseList"
            :key="c_index"
            v-if="nowCourseState >= c_index"
          >
            <div class="item name">{{ course.name }}</div>
            <div class="item time">{{ course.time }}</div>
            <div class="item content">{{ course.content }}</div>
          </div>
        </TransitionGroup>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      swiperList: [
        require("./../../../../assets/imgs/project/projectBigEvent/img0.png"),
      ],
      courseList: [
        {
          name: "项目开工",
          time: "2023.01.05",
          content: "交子公园金融产业园区开始施工",
        },
        {
          name: "项目地基施工",
          time: "2023.02.05",
          content: "交子公园金融产业园区，地基施工",
        },
        {
          name: "项目2层主楼封顶",
          time: "2023.02.20",
          content: "交子公园金融产业园区，项目2层主楼封顶",
        },
        {
          name: "项目5层主楼封顶",
          time: "2023.03.05",
          content: "交子公园金融产业园区，5层主楼封顶",
        },
      ],
      nowCourse: [],
      startState: false,
      nowCourseState: 0,
      startCourseItem: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    startCourse() {
      if (!this.startState) {
        console.log("start");
        this.startState = true;
        this.nowCourseState = 0;
        this.startCourseItem = setInterval(() => {
          this.nowCourseState += 1;
          if (this.nowCourseState == this.nowCourse.length) {
            this.startState = false;
            window.clearInterval(this.startCourseItem);
            this.startCourseItem = null;
            console.log("end");
          }
        }, 1000);
      } else {
        this.startState = false;
        window.clearInterval(this.startCourseItem);
        this.startCourseItem = null;
      }
      ue4("startProjectCourse", this.startState);
    },
  },
  created() {},
  mounted() {
    this.nowCourse = this.courseList;
    this.nowCourseState = this.nowCourse.length;
    console.log("this.nowCourseState", this.nowCourseState);
  },
  beforeDestroy() {
    window.clearInterval(this.startCourseItem);
  },
};
</script>
<style lang='scss' scoped>
.project-big-event {
  position: fixed;
  top: 200px;
  padding: 0 10px;
  width: 100%;
  height: 100vh;
  .left-box {
    width: 723px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    .project-info {
      width: 723px;
      height: 1121px;
      background-image: url("./../../../../assets/imgs/project/projectBigEvent/peroject_info.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-top: 30px;
      position: relative;
      color: #fff;
      .name {
        font-size: 35px;
        font-weight: bold;
        position: absolute;
        left: 50px;
        top: 19px;
      }
      .swiper-box {
        position: absolute;
        top: 88px;
        width: 100%;
      }
      .des {
        position: absolute;
        top: 388px;
        width: 100%;
        font-size: 28px;
        padding: 0 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
        text-indent: 2em;
        margin-top: 15px;
      }
      .info-item {
        position: absolute;
        font-size: 32px;
        top: 651px;
        left: 227px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-shadow: 0px 2px 15px #5990f5;
      }
      .sjdw {
        top: 728px;
      }
      .jldw {
        top: 806px;
      }
      .xmtz {
        top: 884px;
      }
      .jzmj {
        top: 962px;
      }
    }
    .btn {
      width: 155px;
      height: 51px;
      background-image: url("./../../../../assets/imgs/project/projectBigEvent/btn_xmlc.png");
      position: absolute;
      bottom: 15px;
      z-index: 5;
      &:hover {
        cursor: pointer;
        background-image: url("./../../../../assets/imgs/project/projectBigEvent/btn_xmlc_active.png");
      }
    }
    .btn-active {
      background-image: url("./../../../../assets/imgs/project/projectBigEvent/btn_xmlc_active.png");
    }
  }
  .right-box {
    position: absolute;
    top: 0;
    right: 10px;
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .list {
      margin-top: 30px;
      max-height: 1500px;
      overflow-y: scroll;
      .course-item {
        width: 680px;
        height: 169px;
        background-image: url("./../../../../assets/imgs/project/projectBigEvent/course_item.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        position: relative;
        margin-bottom: 15px;
        .item {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          position: absolute;
        }
        .name {
          font-size: 33px;
          left: 50px;
          top: 8px;
          width: 400px;
        }
        .time {
          font-size: 28px;
          left: 466px;
          top: 8px;
        }
        .content {
          font-size: 35px;
          left: 50px;
          top: 60px;
          -webkit-line-clamp: 2;
        }
      }
    }
    ::v-deep ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 12px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 20px;
    }
    ::v-deep ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px #2083d1;
      background-color: #2083d1;
    }
    ::v-deep ::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px #a1a1a1;
      border-radius: 0;
    }
  }
}
</style>